// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"484d9dbe","455":"2e6f400c","977":"a6bb9b8c"}[chunkId] + ".chunk.js";
};